import styled from 'styled-components';
import theme, { themeColors } from 'themes';
import breakpoints from 'constants/breakpoints';

interface ImageOptionProps {
  marginLeft?: string;
  marginTop?: string;
}
type TableProps = {
  tdMarginLeft?: string;
  textAlign?: 'left' | 'center';
  padding?: string;
};

const { size } = breakpoints;
export const StyledTable = styled.table<TableProps>`
  width: -webkit-fill-available;
  text-align: ${({ textAlign }) => textAlign || 'center'};
  overflow: auto; 
  border-collapse: collapse;
  font-size: 14px;
  thead {
    background: #fff;
    position: sticky;
    margin: 0;
    top: 0;
    tr {
      height: 40px;
    }
    th {
      border-bottom: 0.0625rem solid #dadada;
      padding: 0.5rem 0.75rem;
      text-transform: capitalize;
      width: max-content;
      &.action {
        padding-right: 0;
        width: 30px;
      }
    }
    .select-none,
    .disabled-sort {
      display: flex;
      align-items: center;
    }
  }

  /* Apply alternate row coloring + optional borders */
  tbody {
    color: ${themeColors.textLightBlack};
    tr {
      height: 40px;
    }
    td {
      border-bottom: 0.0625rem solid #f3f2f1;
      padding: 8px 0.75rem;
      span {
        float: left;
      }
      &.action {
        padding-right: 0;
      }
    }

    tr:last-child {
      border-bottom: none;
      background-color: transparent;
      & th {
        border-bottom: none;
      }
    }
  }
  table thead .disabled-sort {
    display: inline-block;
    width: 100%;
    overflow: auto;
  }
`;

export const StyledColumnRefContainer = styled.div`
  padding: 0;
  &.is-dragging {
    opacity: 0.5;
    background-color: lightgrey;
  }
  &.is-over {
    opacity: 0;
  }
`;
export const SearchIconWrapper = styled.div`
  position: relative;
  > svg {
    cursor: auto;
    position: absolute;
    left: 0px;
    top: 11px;
    z-index: 1;
    fill: #666666;
  }
`;
export const StyledNonDraggableColumnRefContainer = styled.div`
  padding: 0rem;
`;

export const StyledDragRefContainer = styled.div`
  cursor: grab;
  cursor: -moz-grab;
  cursor: -webkit-grab;
  
  .widget-dropdown-button{
    margin-left: auto;
  }

`;

export const StyledTFoot = styled.tfoot`
  color: gray;
  & th {
    font-weight: normal;
  }
`;

export const StyledAscDescContainer = styled.div`
  margin-left: 0.5rem;
  margin-top: -0.125rem;
  div: nth-child(2) {
    margin-top: -0.625rem;
  }
`;
export const Wrapper = styled.div`
  display: flex;
  gap: 12px;
`;

export const ColumnOptionWrapper = styled.button`
  position: relative;
  color: ${theme.colors.text.lightBlack};
  all: unset;
  box-sizing: border-box;
  padding: 11px;
  display: flex;
  gap: 1rem;
  align-items: center;
  border: 1px solid ${theme.colors.white};
  &:hover {
    background: ${theme.colors.background.background2};
    border-color: ${theme.colors.background.background2};
    outline: 0px;
  }
  &:focus {
    background: ${theme.colors.background.background2};
    outline: 0px;
    border: 1px solid ${theme.colors.primaryBlue5};
    box-shadow: 0px 0px 4px 0px #0076cc30, 0px 0px 4px 0px #0076cc3d inset !important;
  }
  @media (max-width: ${size.md}px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;
export const OptionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  cursor: pointer;
  margin-left: auto;
  position: relative;

  & > input {
    padding-top: 10px;
    margin-bottom: 9px;
    font-size: 14px;
  }

  .column-option-icon {
    padding-right: 8px;
  }

  & .globalSearchInput {
    width: 14rem;
  }
  & .globalSearchInput::placeholder {
    color: #828285;
  }
  .tooltip-icon{
    position: absolute;
    right: 0;
    bottom: 10px
  }
  .icon--information-icon{
    width: 16px;
    height: 16px;
  }  
`;
export const TableButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2rem;
  margin-top: 9px;
  margin-bottom: 9px;
`;
export const ColumnOption = styled.div<{ shadow?: boolean }>`
  display: flex;
  flex-direction: row;
  gap: 2rem;
  justify-content: flex-end;
  align-items: center;
  margin-top: 0.1rem;
  flex-wrap: nowrap;
  box-shadow: ${({ shadow }) => {
    return shadow ? '0px 1px 1px 0px #0000002E' : 'transparent';
  }};
  &.global-search-mobile-view {
    margin-top: 0.5rem;
  }
`;
export const TableFilterOption = styled.div`
  cursor: pointer;
`;
export const FilterSelectWrapper = styled.div`
  top: 1rem;
  display: flex;
  width: 10rem;
  z-index: 100;
`;
export const ImageOptionWrapper = styled.div`
  // position: absolute;
  width: 1.5rem;
  height: 1.5rem;
`;
export const ImageOption = styled.img<ImageOptionProps>`
  width: 100%;
  margin-top: ${(props) => (props.marginTop ? props.marginTop : '0')};
  margin-left: ${(props) => (props.marginLeft ? props.marginLeft : '0')};
`;
export const OptionsModalContainer = styled.div`
  width: 100%;
  padding: 0.5rem 2rem;
`;
export const SelectionHeader = styled.div`
  margin-left: 0rem;
`;
export const OptionalColumnContainer = styled.div`
  width: 100%;
  padding: 0.625rem 0;
  border-bottom: thin solid ${(props) => props.theme.colors.lightGrey6};
`;

export const OptionColumnCheckboxWrapper = styled.div`
  display: flex;
  justify-content: left;
  border: 1px solid ${(props) => props.theme.colors.lightGrey6};
  padding: 0px 0.5rem;
  border-radius: 0.313rem;
  margin-bottom: 10px;
  gap: 0.25rem;
  > p{
    margin:10px 0px; 
  }
`;

export const OptionalColumnName = styled.label`
  display: flex;
  align-items: center;
  text-transform: capitalize;
`;

export const SelectAllOptionalColumn = styled.div`
  display: flex;
  padding: 0rem;
  gap:5px;
`;

export const ModalButtonsContainer = styled.div`
  width: 100%;
  padding-right: 0.75rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  background-color: white;

  button {
    margin: 1rem;
    width: auto;
  }
`;
export const TableCoverRule = styled.div`
  width: 100%;
  border-bottom: 0.063rem solid ${(props) => props.theme.colors.lightGrey3};
`;
export const TableHeaderRule = styled.div`
  width: 100%;
  border-bottom: 0.063rem solid ${(props) => props.theme.colors.lightGrey3};
  margin-bottom: 0.5rem;
`;
export const StyledRootContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 0.8rem;
`;

export const TableHeadBtn = styled.button`
  all: unset;
  display: flex;
  cursor: pointer;
  align-items: center;
`;
